import moment from 'moment'
import React from 'react'
import styled, {
  FOOTER_HEIGHT,
  MOBILE_FOOTER_HEIGHT,
  MQ_TABLET,
  tosLink,
} from '../../constants/theme'
import { returnTrue } from '../../helpers/shouldUpdate'

const StickyFooter = () => (
  <Div className="footer">
    <div>
      <HelpDiv>Need Help?</HelpDiv>
      <div>
        <span>Contact support at&nbsp;</span>
        <Link href="mailto:support@cirrusmd.com">support@cirrusmd.com</Link>
      </div>
    </div>
    <div>
      <span>
        &copy;
        {`${moment().year()} CirrusMD, All Rights Reserved |`}
        &nbsp;
      </span>
      <Link href={tosLink()} rel="noopener noreferrer" target="_blank">
        Terms of Use
      </Link>
      {(window as any).CMD.config.tenant.privacy_policy && (
        <React.Fragment>
          {' | '}
          <Link
            href={(window as any).CMD.config.tenant.privacy_policy}
            rel="noopener noreferrer"
            target="_blank"
          >
            Privacy Policy
          </Link>
        </React.Fragment>
      )}
    </div>
  </Div>
)

const Div = styled.div(
  {
    ...MQ_TABLET({
      '& > div': {
        '&:first-of-type': {
          textAlign: 'left',
        },
        '&:last-of-type': {
          paddingTop: 24,
          textAlign: 'right',
        },
      },
      flexDirection: 'row',
      height: FOOTER_HEIGHT,
      justifyContent: 'space-between',
    }),
    '& > div': {
      '&:last-of-type': {
        paddingTop: 10,
      },
      lineHeight: 1.2,
      textAlign: 'center',
    },
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 13,
    height: MOBILE_FOOTER_HEIGHT,
    justifyContent: 'center',
    maxWidth: 1320,
    position: 'absolute',
    width: '100%',
  },
  ({ theme }) => ({
    ...MQ_TABLET({
      padding: `0 ${theme.padding}px`,
    }),
    background: theme.background,
    color: theme.text,
    padding: `0 ${theme.paddingMobile}px`,
  }),
)

const Link = styled.a(
  {
    textDecoration: 'underline',
  },
  ({ theme }) => ({
    '&:focus, &:hover': {
      opacity: 0.6,
    },
    color: theme.text,
  }),
)

const HelpDiv = styled.div({
  ...MQ_TABLET({
    paddingBottom: 0,
  }),
  fontSize: 18,
  fontWeight: 'bold',
  paddingBottom: 10,
  top: 5,
})

export default React.memo(StickyFooter, returnTrue)
